import { RootState } from 'src/store/store';
import { useSelector } from 'react-redux';
import { ProtectedRoute, ProtectedRouteProps } from 'src/routes/ProtectedRoute';

type ProtectedOnboardingRouteProps = Omit<ProtectedRouteProps, 'condition'> & {
  protectDashboard?: boolean;
};

export const ProtectedOnboardingRoute = (props: ProtectedOnboardingRouteProps) => {
  const { protectDashboard = false, ...rest } = props;

  const isOnboardingCompleted = useSelector(
    (state: RootState) => state.user?.currentUser?.onboarding?.complete
  );

  const condition =
    (protectDashboard && isOnboardingCompleted === false) ||
    (!protectDashboard && isOnboardingCompleted);

  return <ProtectedRoute {...rest} condition={condition} />;
};
